import {Component, ChangeDetectionStrategy} from '@angular/core';
import {LoaderService} from "../../../services/loader/loader.service";


@Component({
  selector: 'app-loader',
  imports: [],
  templateUrl: './loader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {

  constructor(
    private loader: LoaderService
  ) {
  }

  isLoading(): boolean {
    return this.loader.isLoading();
  }
}
